import { NoticeCategoryFactory } from './noticeCategoryFactory';

import type {
  NoticeCategoryEntity,
  NoticeCategoryProps,
} from './noticeCategoryEntity';
import type { NoticeCategoryIRepository } from './noticeCategoryIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { NoticeCategoryJson } from '@/types/domain/notice/entities/noticeCategoryEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * 掲示板カテゴリのレポジトリ
 */
export class NoticeCategoryRepository extends AppsyncRepositoryPvt<
  NoticeCategoryEntity,
  NoticeCategoryProps,
  NoticeCategoryJson
> implements NoticeCategoryIRepository {
  private factory = new NoticeCategoryFactory();

  /**
   * Entity名
   */
  protected get entityName(): EntityName {
    return EntityName.WagakoAppNoticeNoticeCategoryEntity;
  }

  /**
   * データからEntity生成
   * @param props データ
   * @returns Entity
   */
  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
